import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {MarketingList} from "../model/MarketingList";

export const getMarketingList = (id: number): Promise<MarketingList> => {
    return AxiosClientFactory
        .getInstance()
        .get<MarketingList>(`/api/marketingLists/${id}`)
        .then((result) => result.data);
};